import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import { App } from './App';
import './theme.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      <Toaster position="bottom-right" toastOptions={{
        style: {
          background: '#111', color: '#e0e0e0',
          border: '1px solid #222',
          fontFamily: "Consolas, monospace", fontSize: 11,
          letterSpacing: '1px',
        },
      }} />
    </QueryClientProvider>
  </StrictMode>,
);
